import {
  createFailAction,
  createStartAction,
  createSuccessAction,
} from '../redux-util/async-helpers';
import { callApiByName } from '../bridge-proxy';
import { tryRedirectBridgeFailure } from '../redux-route/route-actions';
import * as triggers from './bridge-auto-triggers';
import { getComputedBridgeBrand } from '../redux-watson/watson-config-selectors';
import { getBaseMethod } from './bridge-method-remap';
import { deepClone } from 'app/utils/objects';

function normalizePaginatedResponse(response) {
  if (response.pagination && response.content === undefined) {
    const p = response.pagination;
    const listKey = Object.keys(response).find(k => Array.isArray(response[k]));
    if (listKey) {
      response.content = response[listKey];
    }
    response.offset = p.offset != null ? p.offset : 0;
    response.limit = p.limit != null ? p.limit : 25;
    if (response.last === undefined) {
      const items = response.content || [];
      response.last = items.length < response.limit || p.total === 0;
    }
  }
}

// Bridge has an outstanding task to change these from strings to numbers
function cleanUpResponse(response) {
  normalizePaginatedResponse(response);
  if (typeof response.offset === 'string') {
    response.offset = parseInt(response.offset, 10);
  }
  if (typeof response.limit === 'string') {
    response.limit = parseInt(response.limit, 10);
  }
}

/**
 * Load more pages without extra intervention from the UI
 */
function tryLoadAnotherPage(response, action, store) {
  if (
    !response.last &&
    typeof action.bridge.pagesAfterThis === 'number' &&
    action.bridge.pagesAfterThis !== 0
  ) {
    const newAction = deepClone(action);
    const args = newAction.bridge.args[0];
    args.offset = args.offset + args.limit;
    if (action.bridge.pagesAfterThis !== -1) {
      newAction.bridge.pagesAfterThis = action.bridge.pagesAfterThis - 1;
    }
    store.dispatch(newAction);
  }
}

function runAutoTriggers(apiId, store) {
  const autoTriggers = triggers.methods[apiId];
  if (autoTriggers) {
    autoTriggers.forEach(t => store.dispatch(t));
  }
}

const bridgeMiddleware = store => next => action => {
  if (!action.bridge) {
    // Normal action: pass it on
    return next(action);
  }

  if (action.bridge.apiCall) {
    const apiId = action.bridge.apiCall;
    const apiMethod = getBaseMethod(apiId);
    store.dispatch(createStartAction(apiId, action.bridge.args));
    return new Promise(resolve => {
      callApiByName(
        apiMethod,
        window,
        action.bridge.args,
        getComputedBridgeBrand(store.getState())
      ).then(
        response => {
          cleanUpResponse(response);
          store.dispatch(
            createSuccessAction(apiId, response, action.bridge.args)
          );

          runAutoTriggers(apiId, store);
          tryLoadAnotherPage(response, action, store);

          resolve({
            success: true,
          });
        },
        response => {
          store.dispatch(createFailAction(apiId, response, action.bridge.args));
          store.dispatch(tryRedirectBridgeFailure(response, apiId));
          // This resolves because in a redux context we can end up with lots
          // of uncaught in promise exceptions there's not a great way to handle,
          // since rejections are ok and handled through redux
          resolve({
            success: false,
          });
        }
      );
    });
  }
};

export default bridgeMiddleware;
